export function HeaderSkeleton() {
  return (
    <div className="flex items-start gap-3 animate-pulse">
      <div className="size-12 bg-neutral-700 rounded-lg flex-shrink-0" />
      <div className="flex-1 space-y-2">
        <div className="h-5 bg-neutral-700 rounded w-48" />
        <div className="h-4 bg-neutral-700 rounded w-32" />
      </div>
      <div className="flex flex-col gap-2 items-end">
        <div className="h-6 bg-neutral-700 rounded-full w-20" />
        <div className="h-3 bg-neutral-700 rounded w-16" />
      </div>
    </div>
  );
}

export function TimelineSkeleton() {
  return (
    <div className="flex gap-6 animate-pulse pb-3 border-b border-neutral-700/50">
      {[1, 2, 3].map((i) => (
        <div key={i} className="flex flex-col gap-2">
          <div className="h-3 bg-neutral-700 rounded w-16" />
          <div className="h-4 bg-neutral-700 rounded w-32" />
        </div>
      ))}
    </div>
  );
}

export function AutomationSkeleton() {
  return (
    <div className="bg-neutral-800/50 rounded-lg p-4 space-y-3 animate-pulse">
      <div className="flex items-center justify-between">
        <div className="h-4 bg-neutral-700 rounded w-36" />
        <div className="flex gap-2">
          <div className="h-9 bg-neutral-700 rounded w-32" />
          <div className="h-9 bg-neutral-700 rounded w-36" />
        </div>
      </div>
      <div className="grid gap-2 md:grid-cols-2">
        {[1, 2, 3, 4].map((i) => (
          <div key={i} className="h-4 bg-neutral-700 rounded w-full" />
        ))}
      </div>
    </div>
  );
}

export function MediaSkeleton() {
  return (
    <div className="bg-neutral-800/50 rounded-lg overflow-hidden animate-pulse">
      <div className="w-full aspect-[2/1] bg-neutral-700" />
      <div className="p-2 flex items-center justify-between">
        <div className="h-3 bg-neutral-700 rounded w-32" />
        <div className="flex gap-1">
          <div className="size-6 bg-neutral-700 rounded" />
          <div className="size-6 bg-neutral-700 rounded" />
        </div>
      </div>
    </div>
  );
}

export function ScreenshotsSkeleton() {
  return (
    <div className="bg-neutral-800/50 rounded-lg p-4 space-y-3">
      <div className="h-4 bg-neutral-700 rounded w-32 animate-pulse" />
      <div className="grid grid-cols-2 gap-3">
        {[1, 2, 3, 4].map((i) => (
          <div
            key={i}
            className="bg-neutral-700 rounded-lg aspect-[9/19.5] animate-pulse"
          />
        ))}
      </div>
    </div>
  );
}

export function AndroidDetailsSkeleton() {
  return (
    <div className="bg-neutral-800/50 rounded-lg p-3 space-y-3 animate-pulse">
      <div className="h-4 bg-neutral-700 rounded w-32" />
      <div className="space-y-2">
        {[1, 2, 3, 4].map((i) => (
          <div key={i} className="flex items-start gap-2">
            <div className="h-3 bg-neutral-700 rounded w-24 flex-shrink-0" />
            <div className="h-3 bg-neutral-700 rounded flex-1" />
          </div>
        ))}
      </div>
    </div>
  );
}

export function AddressesSkeleton() {
  return (
    <div className="bg-neutral-800/50 rounded-lg p-4 space-y-3 animate-pulse">
      <div className="h-4 bg-neutral-700 rounded w-32" />
      <div className="space-y-2">
        <div className="space-y-1">
          <div className="h-3 bg-neutral-700 rounded w-20" />
          <div className="h-3 bg-neutral-700 rounded w-full" />
        </div>
        <div className="space-y-1">
          <div className="h-3 bg-neutral-700 rounded w-20" />
          <div className="h-3 bg-neutral-700 rounded w-full" />
        </div>
      </div>
    </div>
  );
}

export function JsonSkeleton() {
  return (
    <div className="bg-neutral-800/50 rounded-lg p-4 space-y-3 animate-pulse">
      <div className="flex items-center justify-between">
        <div className="h-4 bg-neutral-700 rounded w-32" />
        <div className="size-6 bg-neutral-700 rounded" />
      </div>
      <div className="space-y-1">
        {[1, 2, 3, 4, 5].map((i) => (
          <div key={i} className="h-3 bg-neutral-700 rounded w-full" />
        ))}
      </div>
    </div>
  );
}
